'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of account email mobile
 */ const AccountEmailMobile = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                cx: "51.9326",
                cy: "51.995",
                rx: "51.9326",
                ry: "51.995",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43",
                y: "68.6133",
                width: "17.5748",
                height: "5.22651",
                rx: "1.60727",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.4924 18.4414H62.9592C64.5913 18.4505 66.1538 19.1047 67.3064 20.2617C68.4589 21.4187 69.1081 22.9846 69.1126 24.6186V78.5059C69.1081 80.1428 68.4565 81.7114 67.3003 82.8688C66.1441 84.0263 64.5772 84.6786 62.942 84.6831H40.4752C38.8401 84.6786 37.2732 84.0263 36.117 82.8688C34.9608 81.7114 34.3092 80.1428 34.3047 78.5059V66.6535V59.0252V57.1517V24.6186C34.3092 22.9787 34.9631 21.4076 36.1231 20.2496C37.283 19.0917 38.8543 18.4414 40.4924 18.4414Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.3438 68.7051H45.1199C43.7118 68.7051 42.5703 69.8478 42.5703 71.2575C42.5703 72.6671 43.7118 73.8098 45.1199 73.8098H58.3438C59.7519 73.8098 60.8934 72.6671 60.8934 71.2575C60.8934 69.8478 59.7519 68.7051 58.3438 68.7051Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "48.7969",
                y: "73.8125",
                width: "6.0399",
                height: "5.91278",
                rx: "2.95639",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "36.9805",
                y: "21.4043",
                width: "29.6626",
                height: "48.9148",
                rx: "1.97109",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M60.6734 37.3848C61.4719 37.3848 62.2377 37.7023 62.8023 38.2676C63.3668 38.8329 63.684 39.5996 63.684 40.399C63.684 41.1984 63.3668 41.9651 62.8023 42.5303C62.2377 43.0956 61.4719 43.4132 60.6734 43.4132C59.875 43.4132 59.1092 43.0956 58.5446 42.5303C57.98 41.9651 57.6629 41.1984 57.6629 40.399C57.6629 39.5996 57.98 38.8329 58.5446 38.2676C59.1092 37.7023 59.875 37.3848 60.6734 37.3848ZM43.8142 39.7961H56.5C56.4737 39.9921 56.4586 40.1955 56.4586 40.399C56.4586 42.1171 57.4822 43.594 58.9536 44.2534L52.3642 49.2004C51.9352 49.5207 51.3482 49.5207 50.9191 49.2004L42.7304 43.0515C42.275 42.7086 42.0078 42.1736 42.0078 41.6047C42.0078 40.6062 42.8169 39.7961 43.8142 39.7961ZM53.0868 50.165L60.4778 44.6151C60.5417 44.6189 60.6057 44.6189 60.6734 44.6189C60.8767 44.6189 61.0799 44.6038 61.2756 44.5774V51.853C61.2756 53.183 60.1955 54.2643 58.8671 54.2643H44.4163C43.0879 54.2643 42.0078 53.183 42.0078 51.853V44.016L50.1966 50.165C51.0546 50.8093 52.2288 50.8093 53.0868 50.165Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                cx: "60.6746",
                cy: "40.399",
                rx: "3.01059",
                ry: "3.0142",
                fill: theme.ds5.asset[assetColor]["600"]
            })
        ]
    });
};

exports.AccountEmailMobile = AccountEmailMobile;
//# sourceMappingURL=AccountEmailMobile.cjs.map
